import { Locale } from '@core/Entities/Locale/Locale.entity';
import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';
import { useAtomValue } from 'jotai';
import { calculationAtom } from '../../Atoms/Calculation.atom';
import { currentProductAtom } from '../../Atoms/CurrentProduct.atom';
import { selectedProductIdAtom } from '../../Atoms/SelectedProductId.atom';
import { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';
import { isCgi } from '../FinancingCalculator/Helpers/FinanceMap';
import { LegalDisclaimers } from '../FinancingCalculator/LegalDisclaimers/LegalDisclaimers';
import styles from './TermsAndConditions.module.css';

export type TermsAndConditionsProps = {
  locale: Locale;
  strings: CalculatorMessages;
};

export const TermsAndConditions = ({ locale, strings }: TermsAndConditionsProps) => {
  const selectedProductId = useAtomValue(selectedProductIdAtom);

  const calculation = useAtomValue(calculationAtom)!;
  const selectedProduct = selectedProductId && calculation?.products?.[selectedProductId];
  const termsAndConditionsUk =
    selectedProduct &&
    (selectedProduct.infoBubbleText?.termsAndConditions ??
      selectedProduct?.disclaimers?.fullDisclaimer);
  const showPrimaryDisclaimer =
    (selectedProduct && selectedProduct.disclaimers?.primaryCalculationDisclaimer) || '';
  const product = useAtomValue(currentProductAtom);
  const termsAndConditionsCgi = product?.disclaimers?.gdprDisclaimer;

  const captiveId = calculation?.captiveId;
  const isCurrentCgi = isCgi(captiveId);
  const isCgiFinanceEligible = isCurrentCgi && locale === 'fr';

  const { openModal } = useModal();

  const GdprDisclaimer = () => {
    return (
      <Typography variant="body3" Component="p" className={styles.description}>
        <div dangerouslySetInnerHTML={{ __html: termsAndConditionsCgi || '' }} />
      </Typography>
    );
  };

  const handleOpenModal = () => {
    openModal(<GdprDisclaimer />, {
      header: strings?.gdprHeader,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBody,
    });
  };

  return (
    <Typography className={styles.termsAndConditions} variant="caption5" Component="div">
      {locale === 'uk' ? (
        <div>
          <span dangerouslySetInnerHTML={{ __html: `<span>${termsAndConditionsUk}</span>` }} />
          <span>
            <a className={styles.privacy} href="/privacy" target="_blank">
              {strings?.termsPolicy}
            </a>
          </span>
        </div>
      ) : (
        <div>
          <strong> {strings?.termsTitle}</strong>
          <span className={styles.infoIcon}>
            <LegalDisclaimers header={strings.termsTitle} content={showPrimaryDisclaimer} />
          </span>
          {isCgiFinanceEligible && (
            <p onClick={handleOpenModal} className={styles.gdprDisclaimer}>
              {strings?.gdprLink}
            </p>
          )}
        </div>
      )}
    </Typography>
  );
};
